import { Input, Textarea } from "@rebass/forms";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import { Redirect } from "react-router-dom/cjs/react-router-dom.min";
import Select, { components } from "react-select";
import { Tooltip } from "react-tooltip";
import { Box, Button, Flex, Link } from "rebass";
import { Avatar } from "../components";
import CannotOrderMessage from "../components/order/CannotOrderMessage";
import ConfigurationCheck from "../components/order/ConfigurationCheck";
import { SelectDoor } from "../components/order/SelectDoor";
import { ToastMessage } from "../components/order/ToastMessage";
import useGuardCustomerRoute from "../hooks/useGuardCustomerRoute";
import useResponsive from "../hooks/useResponsive";
import ChevronDown from "../icons/ChevronDown";
import Info from "../icons/Info";
import { MainLayout } from "../layouts/MainLayout";
import {
  systemActions,
  yodaCustomerActions,
  yodaMessageActions,
  yodaOrdersActions,
} from "../logic/actions";
import { getLocalizedString } from "../utils";
import config from "../utils/globalConfig";
const NewOrderPage = () => {
  const language = localStorage.getItem("B2BLanguage") == "ITA" ? "it" : "en";
  const dispatch = useDispatch();
  const navigate = useHistory();
  const { customerId } = useParams();
  const { newOrderId } = useSelector((state) => state.yodaOrders);
  const { me } = useSelector((state) => state.yodaStakeholders);
  const [orderTypeValue, setOrderTypeValue] = useState();
  const [seasonValue, setSeasonValue] = useState(undefined);
  const [addressValue, setAddressValue] = useState(undefined);
  const [lineValue, setLineValue] = useState(undefined);
  const [doorsValue, setDoorsValue] = useState([]);
  const [notesValue, setNotesValue] = useState(undefined);
  const [poNumber, setpoNumber] = useState(undefined);
  const [noDoorMessage, setNoDoor] = useState(null);
  const [showDoors, setShowDoors] = useState(false);
  const { customer } = useSelector((state) => state.yodaCustomer);
  const { configuration } = useSelector((state) => state.yodaOrders);
  const [refreshRequiredIndicator, setRefreshRequiredIndicator] =
    useState(false);
  const [errorMap, setErrorMap] = useState({
    orderTypeValue: false,
    seasonValue: false,
    lineValue: false,
    addressValue: false,
    notesValue: false,
    doorsValue: false,
    poNumber: false,
  });
  const seasonRef = useRef();
  const lineRef = useRef();
  const { isMobile, isTabletSm } = useResponsive();
  useGuardCustomerRoute();
  useEffect(() => {
    dispatch(yodaOrdersActions.resetOldOrder());
    dispatch(systemActions.setTab(null));
    dispatch(yodaMessageActions.getMessages(customerId));
    return () => {
      dispatch(yodaMessageActions.clearMessages());
    };
  }, []);
  useEffect(() => {
    if (newOrderId != null) {
      navigate.push("/catalogue/" + newOrderId);
    }
  }, [newOrderId]);
  useEffect(() => {
    if (me?.role === "Customer") {
      localStorage.removeItem("selectedAgent");
    }
  }, [me]);
  useEffect(() => {
    if (customerId) {
      dispatch(yodaCustomerActions.getOne(customerId));
      dispatch(yodaOrdersActions.getOrderConfiguration(customerId));
    }
  }, [customerId]);
  useEffect(() => {
    if (customer && customer.doors) {
      setDoorsValue(customer.doors.filter((d) => d.code == "M"));
    }
  }, [customer]);
  useEffect(() => {
    if (refreshRequiredIndicator) {
      setTimeout(() => {
        setErrorMap({
          orderTypeValue: false,
          seasonValue: false,
          lineValue: false,
          addressValue: false,
          notesValue: false,
          doorsValue: false,
        });
        setRefreshRequiredIndicator(false);
      }, 1000);
    }
  }, [refreshRequiredIndicator]);
  let selectStyle = {
    input: (styles) => ({
      ...styles,
    }),
    control: (styles) => ({
      ...styles,
      border: 0,
      borderRadius: 0,
      backgroundColor: "white",
      fontSize: 12,
      marginTop: 20,
      boxShadow: "none",
    }),
    menu: (styles) => ({
      ...styles,
      border: "1px solid rgba(0,0,0,.2)",
      padding: 0,
      borderRadius: 0,
      fontSize: 12,
      marginTop: 0,
      marginBottom: 0,
      boxShadow: "none",
    }),
    option: (styles) => ({
      ...styles,
      marginTop: 1,
      marginBottom: 1,
    }),
  };
  const orderTypes = useMemo(() => {
    const enableReorder = configuration?.find?.(
      (config) => config?.typeId === 1 && config?.configuration?.length,
    );
    const enableSwap = configuration?.find?.(
      (config) => config?.typeId === 2 && config?.configuration?.length,
    );
    return [
      ...(enableReorder
        ? [
            {
              value: config.ORDER_TYPE_REORDER,
              label: getLocalizedString("REORDER"),
            },
          ]
        : []),
      ...(enableSwap
        ? [{ value: config.ORDER_TYPE_SWAP, label: getLocalizedString("SWAP") }]
        : []),
    ];
  }, [configuration]);
  function orderTypeChange(event) {
    setOrderTypeValue(event.value);
    setSeasonValue(null);
    setLineValue(null);
    seasonRef.current.clearValue();
    lineRef.current.clearValue();
  }
  function seasonChange(event) {
    if (event) {
      setSeasonValue(event.value);
    } else {
      setSeasonValue(null);
    }
  }
  function lineChange(event) {
    if (event) {
      setLineValue(event.value);
    } else {
      setLineValue(null);
    }
  }
  function addressChange(event) {
    setAddressValue(event.value);
  }
  function notesChange(event) {
    setNotesValue(event.target.value);
  }
  function poNumberChange(event) {
    setpoNumber(event.target.value);
  }
  function nextClick(event) {
    let tmpErrorMap = {
      ...errorMap,
    };
    if (orderTypeValue === undefined) {
      tmpErrorMap.orderTypeValue = true;
    }
    if (seasonValue === undefined || seasonValue === null) {
      tmpErrorMap.seasonValue = true;
    }
    if (lineValue === undefined || lineValue === null) {
      tmpErrorMap.lineValue = true;
    }
    if (addressValue === undefined) {
      tmpErrorMap.addressValue = true;
    }
    if (doorsValue.map((d) => d.id).length === 0) {
      tmpErrorMap.doorsValue = true;
    }
    setErrorMap(tmpErrorMap);
    setRefreshRequiredIndicator(true);
    if (Object.keys(tmpErrorMap).filter((e) => tmpErrorMap[e]).length > 0) {
      if (tmpErrorMap.doorsValue == true) {
        setNoDoor(getLocalizedString("No Doors"));
      }
      return;
    } else {
      let seasonId = -1;
      if (configuration && configuration.length > 0) {
        seasonId =
          configuration.find((c) => c.seasonCode == seasonValue)?.seasonId ??
          -1;
      }
      let selectedAgent = localStorage.getItem("selectedAgent");
      let model = {
        accountingPeriodId: customer.accountPeriodId,
        priceContractId: customer.priceContractId,
        paymentId: customer.paymentId,
        change: 1,
        seasonId: seasonValue,
        note: { it: notesValue },
        stakeholderId: customerId,
        orderTypeId: orderTypeValue,
        currencyId: customer.currencyId,
        dateTo: new Date(),
        dateFrom: new Date(),
        orderDate: new Date(),
        stakeHolderDestinationAddressId: addressValue,
        customData: {
          lineId: lineValue,
          ponumber: poNumber,
          doors: doorsValue.map((d) => d.id),
        },
        ...(!!selectedAgent && { agent1Id: selectedAgent }),
      };
      dispatch(yodaOrdersActions.createHeader(model));
    }
  }
  function nextCancel(event) {
    navigate.push("/orders/" + customerId);
  }
  function openDoors() {
    setShowDoors(true);
  }
  function closeDoors() {
    setShowDoors(false);
  }
  let seasonsValue = configuration
    ?.find?.((t) => t.typeId == orderTypeValue)
    ?.configuration.map((c) => {
      return {
        value: c.seasonId,
        label: c.season + " - " + c.seasonDescription[language],
      };
    });
  seasonsValue = seasonsValue?.filter(
    (value, index, self) =>
      index === self.findIndex((t) => t.value === value.value),
  );
  let shippingAddressValues = [];
  if (customer?.address?.length) {
    customer?.address?.map((c) => {
      shippingAddressValues.push({
        value: c.id,
        label:
          c.code +
          (c.name ? " - " + c.name : "") +
          (c.city ? " - " + c.city : "") +
          " - " +
          c.street,
      });
    });
  }
  if (me?.error === "not-authorized") {
    return (
      <Redirect
        to={{
          pathname: "/not-authorized",
          state: {
            yodaError: true,
          },
        }}
      />
    );
  }
  return (
    <MainLayout>
      <ToastMessage
        message={noDoorMessage}
        confirmFunction={() => {
          setNoDoor(null);
        }}
        style={{ width: 600 }}
      />
      <ConfigurationCheck
        message={<CannotOrderMessage />}
        buttonLabelCode="ORDER_PAGE_BACK_BUTTON"
        confirmFunction={() => {
          navigate.push("/orders/" + customerId);
        }}
      />
      {isMobile ? (
        <>
          <Flex width={1} flexDirection="column" p="10px">
            <Avatar
              name={customer && customer.name}
              size={54}
              isPage
              mb="5px"
            />
            <Flex
              ml={85}
              mb={3}
              style={{
                color: "#000",
                fontSize: 14,
              }}
            >
              {getLocalizedString("Mandatory fields").toUpperCase()}
            </Flex>
            <Flex
              width={1}
              backgroundColor={"#F2F2F2"}
              mb={3}
              flexDirection={["column", null, "row"]}
            >
              <Flex width={1} p={3} flexDirection={"column"}>
                <Input
                  placeholder={getLocalizedString("Order info").toUpperCase()}
                  disabled={true}
                  value={getLocalizedString("Order info").toUpperCase()}
                  style={{
                    border: 0,
                    borderBottom: "2px solid rgba(229, 231, 235, 1)",
                    color: "#616161!important",
                  }}
                  sx={{
                    "&:focus": {
                      outline: "none",
                    },
                  }}
                />
                <Select
                  styles={selectStyle}
                  placeholder={getLocalizedString("Order type").toUpperCase()}
                  id="orderType"
                  components={{
                    IndicatorSeparator: () => null,
                    DropdownIndicator: (props) => (
                      <components.DropdownIndicator {...props}>
                        <ChevronDown
                          style={{ width: 24, height: 24, color: "#3e3e3e" }}
                        />
                      </components.DropdownIndicator>
                    ),
                  }}
                  onChange={orderTypeChange}
                  options={orderTypes}
                  isSearchable={false}
                ></Select>
                <Box
                  width={1}
                  height={2}
                  style={{
                    backgroundColor:
                      refreshRequiredIndicator && errorMap.orderTypeValue
                        ? "red"
                        : "",
                  }}
                ></Box>
                <Select
                  styles={selectStyle}
                  onChange={seasonChange}
                  id="season"
                  ref={seasonRef}
                  placeholder={getLocalizedString("Order season").toUpperCase()}
                  components={{
                    IndicatorSeparator: () => null,
                    DropdownIndicator: (props) => (
                      <components.DropdownIndicator {...props}>
                        <ChevronDown
                          style={{ width: 24, height: 24, color: "#3e3e3e" }}
                        />
                      </components.DropdownIndicator>
                    ),
                  }}
                  options={!!configuration?.length && seasonsValue}
                  isSearchable={false}
                ></Select>
                <Box
                  width={1}
                  height={2}
                  style={{
                    backgroundColor:
                      refreshRequiredIndicator && errorMap.seasonValue
                        ? "red"
                        : "",
                  }}
                ></Box>
                <Select
                  styles={selectStyle}
                  onChange={lineChange}
                  ref={lineRef}
                  components={{
                    IndicatorSeparator: () => null,
                    DropdownIndicator: (props) => (
                      <components.DropdownIndicator {...props}>
                        <ChevronDown
                          style={{ width: 24, height: 24, color: "#3e3e3e" }}
                        />
                      </components.DropdownIndicator>
                    ),
                  }}
                  placeholder={getLocalizedString("Order line").toUpperCase()}
                  id="line"
                  options={
                    !!configuration?.length
                      ? configuration
                          .find((t) => t.typeId == orderTypeValue)
                          ?.configuration.filter(
                            (c) => c.seasonId == seasonValue,
                          )
                          .map((c) => ({
                            value: c.lineID,
                            label:
                              c.line +
                              (c.lineDescription[language] !== undefined
                                ? " - " + c.lineDescription[language]
                                : ""),
                          }))
                      : []
                  }
                  isSearchable={false}
                ></Select>
                <Box
                  width={1}
                  height={2}
                  style={{
                    backgroundColor:
                      refreshRequiredIndicator && errorMap.lineValue
                        ? "red"
                        : "",
                  }}
                ></Box>
              </Flex>
              <Flex width={1} p={3} flexDirection={"column"}>
                <Input
                  placeholder={getLocalizedString("Info").toUpperCase()}
                  value={getLocalizedString("Info").toUpperCase()}
                  disabled={true}
                  style={{
                    border: 0,
                    borderBottom: "2px solid rgba(229, 231, 235, 1)",
                    color: "#616161!important",
                  }}
                  sx={{
                    "&:focus": {
                      outline: "none",
                    },
                  }}
                />
                <Select
                  styles={selectStyle}
                  onChange={addressChange}
                  components={{
                    IndicatorSeparator: () => null,
                    DropdownIndicator: (props) => (
                      <components.DropdownIndicator {...props}>
                        <ChevronDown
                          style={{ width: 24, height: 24, color: "#3e3e3e" }}
                        />
                      </components.DropdownIndicator>
                    ),
                  }}
                  placeholder={getLocalizedString(
                    "Shipping address",
                  ).toUpperCase()}
                  id="addresses"
                  options={customer ? shippingAddressValues : []}
                  isSearchable={false}
                ></Select>
                <Box
                  width={1}
                  height={2}
                  style={{
                    backgroundColor:
                      refreshRequiredIndicator && errorMap.addressValue
                        ? "red"
                        : "",
                  }}
                ></Box>
                <Box
                  sx={{
                    position: "relative",
                    marginTop: 20,
                  }}
                >
                  <Input
                    placeholder={getLocalizedString(
                      "PURCHASE_ORDER",
                    ).toUpperCase()}
                    disabled={false}
                    value={poNumber}
                    maxLength={25}
                    onChange={poNumberChange}
                    min={0}
                    sx={{
                      backgroundColor: "white",
                      border: "none",
                      outline: "none",
                      color: "#808080",
                      "::placeholder": {
                        color: "#808080",
                      },
                      fontSize: 12,
                      borderTop: "none",
                      minHeight: 40,
                      paddingRight: 40,
                    }}
                  />
                  <Link
                    data-tooltip-id="info-tooltip"
                    sx={{
                      position: "absolute",
                      right: 0,
                      top: "50%",
                      transform: "translateY(-50%)",
                      right: "8px",
                      cursor: "pointer",
                    }}
                  >
                    <Info
                      style={{
                        width: 24,
                        height: 24,
                      }}
                    />
                  </Link>
                  <Tooltip
                    id="info-tooltip"
                    content={getLocalizedString("PURCHARSE_ORDER_TOOLTIP")}
                    style={{
                      width: 120,
                      backgroundColor: "#707071",
                      zIndex: 1,
                    }}
                  />
                </Box>
                <Textarea
                  id="notes"
                  name="notes"
                  style={{
                    backgroundColor: "white",
                    border: "1px solid rgba(229, 231, 235, 0.5)",
                    height: 100,
                    fontSize: 12,
                    marginTop: 20,
                  }}
                  placeholder={getLocalizedString("Order Notes").toUpperCase()}
                  value={notesValue}
                  onChange={notesChange}
                  multiple={true}
                  sx={{
                    "&:focus": {
                      outline: "none",
                    },
                    "::placeholder": {
                      color: "#808080",
                    },
                    color: "#808080",
                  }}
                />
              </Flex>
            </Flex>
          </Flex>
          {customer?.doors?.length > 1 && (
            <Flex
              width={1}
              px={"10px"}
              flexDirection={"column-reverse"}
              marginBottom={"16px"}
            >
              <Flex width={"45%"} flexDirection="column">
                <Button
                  className="w-full"
                  onClick={() => openDoors()}
                  sx={{
                    "&:hover": {
                      color: "white",
                      backgroundColor: "#909090",
                      border: "1px solid #909090",
                    },
                    border: "1px solid #333",
                    backgroundColor: "white",
                    color: "black",
                    marginRight: "10px",
                  }}
                >
                  {getLocalizedString("Select door")}
                </Button>
                <Box
                  width={1}
                  height={2}
                  style={{
                    backgroundColor:
                      refreshRequiredIndicator && errorMap.doorsValue
                        ? "red"
                        : "",
                  }}
                ></Box>
              </Flex>
            </Flex>
          )}
          <Flex
            bg="#303130"
            p="10px"
            mb="-10px"
            width={1}
            justifyContent="space-between"
          >
            <Button onClick={nextCancel} bg="#fff" color="black" width="45%">
              {getLocalizedString("Annulla")}
            </Button>
            <Button
              sx={{ border: "1px solid white" }}
              onClick={nextClick}
              width="45%"
            >
              {getLocalizedString("Prossimo")}
            </Button>
          </Flex>
        </>
      ) : (
        <Flex width={1} flexDirection="column" mb={4} p={[3, null, 0]}>
          <Avatar
            name={customer && customer.name}
            size={54}
            isPage
            style={{
              marginTop: 40,
              marginBottom: -10,
            }}
            pl={[3, null, 0]}
          />
          <Flex
            ml={isTabletSm ? 100 : 85}
            mb={3}
            style={{
              color: "#000",
              fontSize: 14,
            }}
          >
            {getLocalizedString("Mandatory fields").toUpperCase()}
          </Flex>
          <Flex
            width={1}
            backgroundColor={"#F2F2F2"}
            mb={3}
            flexDirection={["column", null, "row"]}
          >
            <Flex width={1} p={3} flexDirection={"column"}>
              <Input
                placeholder={getLocalizedString("Order info").toUpperCase()}
                disabled={true}
                value={getLocalizedString("Order info").toUpperCase()}
                style={{
                  border: 0,
                  borderBottom: "2px solid rgba(229, 231, 235, 1)",
                  color: "#616161!important",
                }}
                sx={{
                  "&:focus": {
                    outline: "none",
                  },
                }}
              />
              <Select
                styles={selectStyle}
                placeholder={getLocalizedString("Order type").toUpperCase()}
                id="orderType"
                components={{
                  IndicatorSeparator: () => null,
                  DropdownIndicator: (props) => (
                    <components.DropdownIndicator {...props}>
                      <ChevronDown
                        style={{ width: 24, height: 24, color: "#3e3e3e" }}
                      />
                    </components.DropdownIndicator>
                  ),
                }}
                onChange={orderTypeChange}
                options={orderTypes}
                isSearchable={false}
              ></Select>
              <Box
                width={1}
                height={2}
                style={{
                  backgroundColor:
                    refreshRequiredIndicator && errorMap.orderTypeValue
                      ? "red"
                      : "",
                }}
              ></Box>
              <Select
                styles={selectStyle}
                onChange={seasonChange}
                id="season"
                ref={seasonRef}
                placeholder={getLocalizedString("Order season").toUpperCase()}
                components={{
                  IndicatorSeparator: () => null,
                  DropdownIndicator: (props) => (
                    <components.DropdownIndicator {...props}>
                      <ChevronDown
                        style={{ width: 24, height: 24, color: "#3e3e3e" }}
                      />
                    </components.DropdownIndicator>
                  ),
                }}
                options={!!configuration?.length ? seasonsValue : []}
                isSearchable={false}
              ></Select>
              <Box
                width={1}
                height={2}
                style={{
                  backgroundColor:
                    refreshRequiredIndicator && errorMap.seasonValue
                      ? "red"
                      : "",
                }}
              ></Box>
              <Select
                styles={selectStyle}
                onChange={lineChange}
                ref={lineRef}
                components={{
                  IndicatorSeparator: () => null,
                  DropdownIndicator: (props) => (
                    <components.DropdownIndicator {...props}>
                      <ChevronDown
                        style={{ width: 24, height: 24, color: "#3e3e3e" }}
                      />
                    </components.DropdownIndicator>
                  ),
                }}
                placeholder={getLocalizedString("Order line").toUpperCase()}
                id="line"
                options={
                  !!configuration?.length
                    ? configuration
                        .find((t) => t.typeId == orderTypeValue)
                        ?.configuration.filter((c) => c.seasonId == seasonValue)
                        .map((c) => ({
                          value: c.lineID,
                          label:
                            c.line +
                            (c.lineDescription[language] !== undefined
                              ? " - " + c.lineDescription[language]
                              : ""),
                        }))
                    : []
                }
                isSearchable={false}
              ></Select>
              <Box
                width={1}
                height={2}
                style={{
                  backgroundColor:
                    refreshRequiredIndicator && errorMap.lineValue ? "red" : "",
                }}
              ></Box>
            </Flex>
            <Flex width={1} p={3} flexDirection={"column"}>
              <Input
                placeholder={getLocalizedString("Info").toUpperCase()}
                value={getLocalizedString("Info").toUpperCase()}
                disabled={true}
                style={{
                  border: 0,
                  borderBottom: "2px solid rgba(229, 231, 235, 1)",
                  color: "#616161!important",
                }}
                sx={{
                  "&:focus": {
                    outline: "none",
                  },
                }}
              />
              <Select
                styles={selectStyle}
                onChange={addressChange}
                components={{
                  IndicatorSeparator: () => null,
                  DropdownIndicator: (props) => (
                    <components.DropdownIndicator {...props}>
                      <ChevronDown
                        style={{ width: 24, height: 24, color: "#3e3e3e" }}
                      />
                    </components.DropdownIndicator>
                  ),
                }}
                placeholder={getLocalizedString(
                  "Shipping address",
                ).toUpperCase()}
                id="addresses"
                options={customer ? shippingAddressValues : []}
                isSearchable={false}
              ></Select>
              <Box
                width={1}
                height={2}
                style={{
                  backgroundColor:
                    refreshRequiredIndicator && errorMap.addressValue
                      ? "red"
                      : "",
                }}
              ></Box>
              <Box
                sx={{
                  position: "relative",
                  marginTop: 20,
                }}
              >
                <Input
                  placeholder={getLocalizedString(
                    "PURCHASE_ORDER",
                  ).toUpperCase()}
                  disabled={false}
                  maxLength={25}
                  value={poNumber}
                  onChange={poNumberChange}
                  type="string"
                  min={0}
                  sx={{
                    backgroundColor: "white",
                    border: "none",
                    outline: "none",
                    color: "#808080",
                    fontSize: 12,
                    borderTop: "none",
                    "::placeholder": {
                      color: "#808080",
                    },
                    paddingRight: 40,
                    height: 40,
                    borderBottom:
                      refreshRequiredIndicator && errorMap.poNumber
                        ? "2px solid red"
                        : "none",
                  }}
                />
                <Link
                  data-tooltip-id="info-tooltip"
                  sx={{
                    position: "absolute",
                    right: 0,
                    top: "50%",
                    transform: "translateY(-50%)",
                    right: "8px",
                    cursor: "pointer",
                  }}
                >
                  <Info
                    style={{
                      width: 24,
                      height: 24,
                    }}
                  />
                </Link>
                <Tooltip
                  id="info-tooltip"
                  content={getLocalizedString("PURCHARSE_ORDER_TOOLTIP")}
                  style={{
                    zIndex: 100,
                    backgroundColor: "#707071",
                  }}
                />
              </Box>
              <Textarea
                id="notes"
                name="notes"
                style={{
                  backgroundColor: "white",
                  border: "1px solid rgba(229, 231, 235, 0.5)",
                  height: 100,
                  fontSize: 12,
                  marginTop: 20,
                }}
                placeholder={getLocalizedString("Order Notes").toUpperCase()}
                value={notesValue}
                onChange={notesChange}
                multiple={true}
                sx={{
                  "&:focus": {
                    outline: "none",
                    "::placeholder": {
                      color: "#808080",
                    },
                    color: "#808080",
                  },
                }}
              />
            </Flex>
          </Flex>
          <Flex p={3} justifyContent="space-between">
            <Flex flexDirection={"column-reverse"} alignItems="center">
              {customer?.doors?.length > 1 && (
                <Flex flexDirection="column">
                  <Button
                    className="w-full"
                    onClick={() => openDoors()}
                    sx={{
                      border: "1px solid #333",
                      color: "black",
                      marginRight: "10px",
                      "&:hover": {
                        backgroundColor: "#909090",
                        color: "white",
                        border: "1px solid #909090",
                      },
                    }}
                  >
                    {getLocalizedString("Select door")}
                  </Button>
                  <Box
                    width={1}
                    height={2}
                    style={{
                      backgroundColor:
                        refreshRequiredIndicator && errorMap.doorsValue
                          ? "red"
                          : "",
                    }}
                  ></Box>
                </Flex>
              )}
            </Flex>
            <Flex>
              <Button
                onClick={nextCancel}
                sx={{
                  "&:hover": {
                    color: "white",
                    backgroundColor: "#909090",
                    border: "1px solid #909090",
                  },
                  border: "1px solid #333",
                  backgroundColor: "white",
                  width: "150px",
                  color: "black",
                  marginRight: "10px",
                }}
              >
                {getLocalizedString("Annulla")}
              </Button>
              <Button
                onClick={nextClick}
                sx={{
                  "&:hover": {
                    backgroundColor: "#909090",
                    border: "1px solid #909090",
                  },
                  border: "1px solid #333",
                  backgroundColor: "#333",
                  width: "150px",
                  marginLeft: "10px",
                }}
              >
                {getLocalizedString("Prossimo")}
              </Button>
            </Flex>
          </Flex>
        </Flex>
      )}
      {showDoors && (
        <SelectDoor
          closeDoors={closeDoors}
          doors={customer && customer.doors}
          selected={doorsValue}
          save={(selected) => {
            setDoorsValue(selected);
          }}
          style={{
            width: isMobile ? "calc(100% - 28px)" : 500,
          }}
        />
      )}
    </MainLayout>
  );
};
export { NewOrderPage };